
import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import HttpClient from "src/http/http-client";
import { GaodeService, OrganizationService } from "src/services";

/**
 * 加项包
 * @class
 * @version 1.0.0
 */
export default class SupplierService extends ServiceBase
{

    /*
     * 服务实例
     * @private
     * @return SupplierService
     */
    private static _instance: SupplierService;

    /**
     * 加项包服务实例
     * @static
     * @property
     * @returns SupplierService
     */
    public static get instance(): SupplierService
    {
        if(!this._instance)
        {
            this._instance = new SupplierService();
        }
        
        return this._instance;
    }


    /**
     * 获取加项包项目
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getApptNotice(id: any): Promise<IHttpResponse>
    {

        let response = await this.apis.getApptNotice({
            params: {orgId:id}
        });

        return response;
    }


}
